// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__1Km8P","heading":"AboutUs_heading__kw1Ix","text":"AboutUs_text__TGjCF"};